module.exports = __webpack_public_path__ + "img/ic_drag_handler.78b233c2.svg";